import { useState } from 'react'
import axios from 'axios'

function LoginForm(){
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    const authObject = {'Project-ID' : '8f4cb02a-64df-44c6-8386-8b0a10f1378c', 'User-Name' : username, 'User-Secret' : password}
    try{
      await axios.get('https://api.chatengine.io/chats', {headers:authObject})
      localStorage.setItem('username', username)
      localStorage.setItem('password', password)
      window.location.reload()
    } catch(error){
      setError('Oops! Incorrect credentials')
    }
  }


  return (
    <div className='wrapper'>
      <div className='form'>
        <h1 className='title'>Chat Application</h1>
        <div align='center' className='heads'>
          <h3 className='heads'>Login as a trial user:</h3>
          <h4>Username : TrialUser or TrialUser2</h4>
          <h4>Password : trial123</h4>
        </div>
        <form onSubmit={handleSubmit}>
          <input type='text' value={username} onChange={(e) => setUsername(e.target.value)} className='input' placeholder='Username' required />
          <input type='password' value={password} onChange={(e) => setPassword(e.target.value)} className='input' placeholder='Password' required />
          <div align='center'>
            <button type='submit' className='button'><span>Start Chatting</span></button>
          </div>
          <h2 className='error'>{error}</h2>
      </form>
      </div>
    </div>
  )
}

export default LoginForm
